import {
    CASHLIFTAPPROVEREJECTPARTNER_SUCCESS,
    CASHLIFTAPPROVEREJECTPARTNER_FAILED,
    RESET_CASHLIFTAPPROVEREJECTPARTNER,
    LOADING_CASHLIFTAPPROVEREJECTPARTNER,
    NETWORK_ERROR_CASHLIFTAPPROVEREJECTPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetCashLiftApproveRejectForPartner = () => {
    return { type: RESET_CASHLIFTAPPROVEREJECTPARTNER };
};


const partnerCashLiftApproveRejectReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_CASHLIFTAPPROVEREJECTPARTNER });
    await partnerServices
        .post("cashLiftapproverejectPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerCashLiftApproveRejectReqListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerCashLiftApproveRejectReqListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_CASHLIFTAPPROVEREJECTPARTNER,
                payload: err
            });
        });
};


function partnerCashLiftApproveRejectReqListsuccess(data) {
    return {
        type: CASHLIFTAPPROVEREJECTPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerCashLiftApproveRejectReqListFailed(data) {
    return {
        type: CASHLIFTAPPROVEREJECTPARTNER_FAILED,
        payload: data,
    };
}

export { resetCashLiftApproveRejectForPartner, partnerCashLiftApproveRejectReqList }